const autoResizeWindow = document.querySelector('[data-auto-resize-window]');

if ( autoResizeWindow ) {
	window.resizeTo( window.outerWidth, Math.max( window.outerHeight, document.documentElement.scrollHeight ) );
}
